import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type SMSTemplate = {
  sms_template_id?: number; // 문자 템플릿 idx
  sms_template: string; // 템플릿 내용
  type?: string; // 타입
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] SMSTemplate
   * --
   */
  getSMSTemplates: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_SMS_TEMPLATE, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] SMSTemplate
   * --
   */
  getSMSTemplate: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_SMS_TEMPLATE, {
        sms_template_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] SMSTemplate
   * --
   */
  createSMSTemplate: async (body: SMSTemplate) => {
    try {
      const res = await $http.post(APIConstant.CREATE_SMS_TEMPLATE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] SMSTemplate
   * --
   */
  updateSMSTemplate: async (body: SMSTemplate) => {
    try {
      const { sms_template_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_SMS_TEMPLATE, {
        sms_template_id: sms_template_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] SMSTemplate
   * --
   */
  deleteSMSTemplate: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_SMS_TEMPLATE, {
        sms_template_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
